import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class MastersService {
  constructor(private api: ApiService) {}

  // ✅ projects
  getProducts(): Observable<any[]> {
    return this.api.get<any[]>('projects');
  }

  createProduct(data: any): Observable<any> {
    return this.api.post('projects', data);
  }

  updateProduct(id: string, data: any): Observable<any> {
    return this.api.patch(`projects/${id}`, data);
  }

  deleteProduct(id: string): Observable<any> {
    return this.api.delete(`projects/${id}`);
  }

  // ✅ Modules
  createModule(productId: string, data: any): Observable<any> {
    return this.api.post(`projects/${productId}/modules`, data);
  }
  
  getModules(projectId: string): Observable<any> {
    return this.api.get<any>(`projects/${projectId}/modules`);
  }

  updateModule(moduleId: string, data: any): Observable<any> {
    return this.api.patch(`projects/modules/${moduleId}`, data);
  }

  deleteModule(moduleId: string): Observable<any> {
    return this.api.delete(`projects/modules/${moduleId}`);
  }
}
